import AccountType from '../../shared/enums/AccountType.enum';

export enum InvestingEntityType {
  None = 0,
  LLC = 1,
  LLP = 2,
  Personal = 3,
  Trust = 4,
  Inc = 5,
  Ltd = 6,
  RetirementPlan = 7,
  LP = 8,
  Other = 9

}

// tslint:disable-next-line:no-namespace
export namespace InvestingEntityType {
  export function toString(iet: InvestingEntityType): string {
    switch (iet) {
      case InvestingEntityType.LLC:
        return 'LLC';
      case InvestingEntityType.LLP:
        return 'LLP';
      case InvestingEntityType.Personal:
        return 'Personal';
      case InvestingEntityType.Trust:
        return 'Trust';
      case InvestingEntityType.Inc:
        return 'Inc';
      case InvestingEntityType.Ltd:
        return 'Ltd';
      case InvestingEntityType.RetirementPlan:
        return 'Retirement Plan';
      case InvestingEntityType.LP:
        return 'LP';
      case InvestingEntityType.Other:
        return 'Other';

      default:
        return null;
    }
  }

  export function listAll() {
    return [
      InvestingEntityType.Inc,
      InvestingEntityType.LLC,
      InvestingEntityType.LLP,
      InvestingEntityType.LP,
      InvestingEntityType.Ltd,
      InvestingEntityType.Other,
      InvestingEntityType.Personal,
      InvestingEntityType.RetirementPlan,
      InvestingEntityType.Trust
    ];
  }

  export function parse(str: string): InvestingEntityType {
    return InvestingEntityType[str];
  }

  export function getIcon(type: InvestingEntityType) {
    switch (type) {
      case InvestingEntityType.LLC:
        return 'llc';
      case InvestingEntityType.LLP:
        return 'llp';
      case InvestingEntityType.Personal:
        return 'personal';
      case InvestingEntityType.Trust:
        return 'trust';
      case InvestingEntityType.Inc:
        return 'inc';
      case InvestingEntityType.Ltd:
        return 'ltd';
      case InvestingEntityType.RetirementPlan:
        return 'plan';
      case InvestingEntityType.LP:
        return 'lp';
      case InvestingEntityType.Other:
        return '';

      default:
        return null;
    }
  }
}

export default InvestingEntityType;
